export const SCHOOL = 1;
export const WAREHOUSE = 2;
export const KITCHEN = 3;

export const SITE_TYPE = [
  { id: SCHOOL, description: 'School' },
  { id: WAREHOUSE, description: 'Warehouse' },
  { id: KITCHEN, description: 'Kitchen' },
];

export const SITE_MULTIPLIER = '1.60';

export const UNASSIGNED_SITE_GROUP = 99999;

export const ORDER_PREFERENCE_OPTIONS = [
  {
    text: 'Warehouse/Kitchen if Available',
    key: 'wareHouseKitchenIfAvailable',
    value: 1,
  },
  { text: 'Warehouse/Kitchen', key: 'wareHouseKitchen', value: 2 },
  { text: 'Distributor Direct', key: 'vendor', value: 3 },
];



// WEBPACK FOOTER //
// ./src/common/Constants/site.js